import "./contignant.css";
import { Grid } from "@material-ui/core";
import GliGrid from "../gliGrid/GliGrid";
import { ContingentBeneficierytProps } from "../../../../../../../../../@types/components/gliFormProps.types";

// eslint-disable-next-line react/prop-types
const ContignantBeneficiary = ({ isPrintable, contingentBeneficiery }: ContingentBeneficierytProps) => {
	return (
		<>
			<div className={isPrintable ? "gli-contignant-header-print font-size-md" : "gli-contignant-header"}>
				CONTINGENT BENEFICIARY(IES):{" "}
				<span className="gli-contignant-sub-header">
					Contingent beneficiaries will only receive benefit if there are no surviving primary beneficiaries
				</span>
			</div>
			<div className="contignant-beneficary-container">
				<Grid container spacing={1}>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="gli-contignant-grid-header">
						<div
							className={
								isPrintable
									? "contignant-grid-header-label font-size-small"
									: "contignant-grid-header-label"
							}
						>
							Contignant Beneficiary’s Name and Address
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-contignant-grid-header2">
						<div
							className={
								isPrintable
									? "contignant-grid-header-label1 font-size-small"
									: "contignant-grid-header-label1"
							}
						>
							Social Security<br></br> Number
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-contignant-grid-header3">
						<div
							className={
								isPrintable
									? "contignant-grid-header-label font-size-small"
									: "contignant-grid-header-label"
							}
						>
							Relationship<br></br> To You
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-contignant-grid-header4">
						<div
							className={
								isPrintable
									? "contignant-grid-header-label font-size-small"
									: "contignant-grid-header-label"
							}
						>
							Date of Birth
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-contignant-grid-header5">
						<div
							className={
								isPrintable
									? "contignant-grid-header-label font-size-small"
									: "contignant-grid-header-label"
							}
						>
							<p>
								Percentage:<br></br>Must equal 100%
							</p>
						</div>
					</Grid>
				</Grid>
				{contingentBeneficiery ? (
					<GliGrid isPrintable={isPrintable} eachBeneficery={contingentBeneficiery[0]} />
				) : null}
				{contingentBeneficiery ? (
					<GliGrid isPrintable={isPrintable} eachBeneficery={contingentBeneficiery[1]} />
				) : null}
				{contingentBeneficiery ? (
					<GliGrid isPrintable={isPrintable} eachBeneficery={contingentBeneficiery[2]} />
				) : null}
			</div>
		</>
	);
};

export default ContignantBeneficiary;
